import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_checkbox_field = _resolveComponent("checkbox-field")
  const _component_custom_select_field = _resolveComponent("custom-select-field")

  return (_openBlock(), _createBlock(_component_custom_select_field, _mergeProps({..._ctx.$attrs, ..._ctx.$props}, {
    placeholder: $options.placeholderText,
    "data-qa": `multi-checkbox-field:${$props.displayName}`
  }), {
    description: _withCtx(() => [
      _renderSlot(_ctx.$slots, "description")
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.optionsArray, (option) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `multi-checkbox-item-${option.value}`
        }, [
          _createVNode(_component_checkbox_field, {
            "model-value": $props.modelValue,
            "display-name": option.name,
            "checked-value": option.value,
            "read-only": option.readOnly,
            disabled: option.disabled,
            inline: true,
            condensed: true,
            "onUpdate:modelValue": $options.onInput,
            "data-qa": `multi-checkbox-item:${option.name}`
          }, null, 8 /* PROPS */, ["model-value", "display-name", "checked-value", "read-only", "disabled", "onUpdate:modelValue", "data-qa"])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */, ["placeholder", "data-qa"]))
}